<template>
  <div @click="closeDialog()" id="show_qr">
    <img :src="info.url" alt>
  </div>
</template>
<script>
export default {
  name: "imgDialog",
  data () {
    return {
      info: this.previewInfo
    }
  },
  props: {
    previewInfo: {
      type: [Object],
      required: true
    },
  },
  methods: {
    closeDialog () {
      //给父组件传参
      this.$emit('closeDialog', false)
    }
  }
}
</script>
<style scoped>
#show_qr {
  top: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
}
#show_qr img {
  margin: 10em auto;
  width: 80%;
  display: block;
}
.popup #show_qr {
  position: absolute;
}
.popup #show_qr img {
  margin: 6em auto;
}
</style>


// WEBPACK FOOTER //
// src/components/imgDialog/imgDialog.vue